<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <div class="form-group row">
            <div class="col-xl-2 col-md-2">
              <h5>Operatori</h5>
            </div>
          </div>
        </div>
        <div class="card-body tab2-card">
          <ngb-tabset class="tab-coupon">
            <ngb-tab title="Energie Electrica" id="energie-electrica">
              <ng-template ngbTabContent>
                <div class="form-group row">
                  <div class="col-xl-3 col-md-3">
                    <input class="form-control" type="text" placeholder="CUI" [(ngModel)]="codeFilterElectr" required>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <input class="form-control" type="text" placeholder="Denumire" [(ngModel)]="nameFilterElectr" required>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <button type="button" class="btn btn-primary" (click)="search()">
                      Cauta
                    </button>
                  </div>
                </div>
                <div class="category-table custom-datatable">
                  <div class="table-responsive">
                    <ng2-smart-table [settings]="electricOperatorsDisplaySettings" [source]="eeOperators"
                                     (custom)="onCustomActionElectricSuppliers($event)">
                    </ng2-smart-table>
                  </div>
                </div>
                <div>
                  <h4 class="pagination justify-content-center">
                    Total Operatori {{totalResultsElectr}}
                  </h4>
                  <ul class="pagination justify-content-center">
                    <li class="page-item" (click)="previousPage()">
                      <a class="page-link" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                        <span class="sr-only">Previous</span>
                      </a>
                    </li>
                    <li *ngFor="let page of paginationElementsElectr" [ngClass]="page.className" (click)="changePage(page)">
                      <a class="page-link" >{{page.pageNumber + 1}}</a>
                    </li>
                    <li class="page-item" (click)="nextPage()">
                      <a class="page-link" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                        <span class="sr-only">Next</span>
                      </a>
                    </li>
                  </ul>
                </div>

              </ng-template>
            </ngb-tab>
            <ngb-tab title="Gaze Naturale" id="gaze-naturale">
                <ng-template ngbTabContent>
                  <div class="form-group row">
                    <div class="col-xl-3 col-md-3">
                      <input class="form-control" type="text" placeholder="CUI" [(ngModel)]="codeFilterGas" required>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <input class="form-control" type="text" placeholder="Denumire" [(ngModel)]="nameFilterGas" required>
                    </div>
                    <div class="col-xl-3 col-md-3">
                      <button type="button" class="btn btn-primary" (click)="search()">
                        Cauta
                      </button>
                    </div>
                  </div>
                  <div class="category-table custom-datatable">
                    <div class="table-responsive">
                      <ng2-smart-table [settings]="gasOperatorsDisplaySettings" [source]="gnOperators"
                                       (custom)="onCustomActionGasSuppliers($event)">
                      </ng2-smart-table>
                    </div>
                  </div>
                  <div>
                    <h4 class="pagination justify-content-center">
                      Total Operatori {{totalResultsGas}}
                    </h4>
                    <ul class="pagination justify-content-center">
                      <li class="page-item" (click)="previousPage()">
                        <a class="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span class="sr-only">Previous</span>
                        </a>
                      </li>
                      <li *ngFor="let page of paginationElementsGas" [ngClass]="page.className" (click)="changePage(page)">
                        <a class="page-link" >{{page.pageNumber + 1}}</a>
                      </li>
                      <li class="page-item" (click)="nextPage()">
                        <a class="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span class="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-template>
            </ngb-tab>
          </ngb-tabset>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
